import { render, staticRenderFns } from "./prnpolicy_audit.vue?vue&type=template&id=c837ddb0&scoped=true"
import script from "./prnpolicy_audit.vue?vue&type=script&lang=js"
export * from "./prnpolicy_audit.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./prnpolicy_audit.vue?vue&type=style&index=1&id=c837ddb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c837ddb0",
  null
  
)

export default component.exports